import { Theme } from '@mui/material/styles'

const muiAlert = (theme: Theme) => {
  return {
    styleOverrides: {
      root: {
        borderRadius: 12,
        padding: '0.5rem',
        alignItems: 'center'
      },
      standardError: {
        background: theme.palette.error.light,
        color: theme.palette.text.primary,
        '& .MuiAlert-icon ': {
          background: theme.palette.error.main,
          color: '#fff'
        }
      },
      standardSuccess: {
        background: theme.palette.success.light,
        color: theme.palette.text.primary,
        '& .MuiAlert-icon ': {
          background: theme.palette.success.main,
          color: '#fff'
        }
      },
      standardWarning: {
        background: theme.palette.warning.light,
        color: theme.palette.text.primary,
        '& .MuiAlert-icon ': {
          background: theme.palette.warning.main,
          color: '#fff'
        }
      },
      standardInfo: {
        background: theme.palette.info.light,
        color: theme.palette.text.primary,
        '& .MuiAlert-icon ': {
          background: theme.palette.primary.main,
          color: '#fff'
        }
      },
      icon: {
        height: '2rem',
        width: '2rem',
        borderRadius: 8,
        marginRight: '1rem',
        padding: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: '0 0 2rem'
      },
      message: {
        padding: 0
      }
    }
  }
}

export default muiAlert
